import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useSystemAdmin } from "@/hooks/useSystemAdmin";

/** Platform admin routes — requires `profiles.is_super_admin`. */
export const SystemAdminGuard = () => {
  const { isSystemAdmin, isLoading } = useSystemAdmin();

  if (isLoading) {
    return (
      <div className="flex flex-1 h-full w-full items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin text-white" aria-label="Loading" />
      </div>
    );
  }

  if (!isSystemAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
